<div class="multi-chart-container" [ngClass]="'charts-'+chartsCount">

  <!-- role="group" + aria-label lets AT announce which chart panel is active -->
  <div class="chart-container" role="group" [attr.aria-label]="('chart.panel.label' | translate : { n: 1, total: chartsCount })" [ngClass]="{'disabled':currentParamsList!=0 && isSidebarOpen==true}">
    <plan-detail-chart-v2 [contactType]="contactType"
                       [isVisible]="isVisible"
                       [displayFooter]="true"
                       [displayHeader]="true"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [viewMode]="gridContext?.viewMode"
                       [gridContext]="gridContext"
                       [isLoading]="isLoading"
                       (paramsListChanged)="onParamsListChanged($event,0)"
                       [sidebar]="sidebar[0]"
                       [chartId]=0
                       #chart0
                       (pointHovered)="onPointHovered(chart0,$event)"
                       (pointOut)="onPointOut(chart0,$event)"
                       (setExtremes)="onSetExtremes($event)"
                       (drillDown)="updateViewMode(false)"
                       (rollUp)="updateViewMode(true)"
                       (displayParams)="onDisplayParams(0)"
                       [locale]="locale"
    ></plan-detail-chart-v2>
  </div>
  <div class="chart-container" role="group" [attr.aria-label]="('chart.panel.label' | translate : { n: 2, total: chartsCount })" [ngClass]="{'disabled':currentParamsList!=1 && isSidebarOpen==true}">
    <plan-detail-chart-v2 [contactType]="contactType"
                       [isVisible]="isVisible"
                       (pointHovered)="onPointHovered(chart1,$event)"
                       (pointOut)="onPointOut(chart1,$event)"
                       (setExtremes)="onSetExtremes($event)"
                       [displayFooter]="true"
                       [displayHeader]="false"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [viewMode]="gridContext?.viewMode"
                       [gridContext]="gridContext"
                       [isLoading]="isLoading"
                       [sidebar]="sidebar[1]"
                       (paramsListChanged)="onParamsListChanged($event,1)"
                       [chartId]=1
                       #chart1
                       (drillDown)="updateViewMode(false)"
                       (rollUp)="updateViewMode(true)"
                       (displayParams)="onDisplayParams(1)"
                       [locale]="locale"
    ></plan-detail-chart-v2>


  </div>
  <div class="chart-container" role="group" [attr.aria-label]="('chart.panel.label' | translate : { n: 3, total: chartsCount })" [ngClass]="{'disabled':currentParamsList!=2 && isSidebarOpen==true}">
    <plan-detail-chart-v2 [contactType]="contactType"
                       [isVisible]="isVisible"
                       [displayFooter]="true"
                       [displayHeader]="false"
                       (pointHovered)="onPointHovered(chart2,$event)"
                       (pointOut)="onPointOut(chart2,$event)"
                       (setExtremes)="onSetExtremes($event)"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [viewMode]="gridContext?.viewMode"
                       [gridContext]="gridContext"
                       [isLoading]="isLoading"
                       (paramsListChanged)="onParamsListChanged($event,2)"
                       [sidebar]="sidebar[2]"
                       [chartId]=2
                       #chart2
                       (drillDown)="updateViewMode(false)"
                       (rollUp)="updateViewMode(true)"
                       (displayParams)="onDisplayParams(2)"
                       [locale]="locale"
    ></plan-detail-chart-v2>


  </div>
  <div class="chart-container" role="group" [attr.aria-label]="('chart.panel.label' | translate : { n: 4, total: chartsCount })" [ngClass]="{'disabled':currentParamsList!=3 && isSidebarOpen==true}">
    <plan-detail-chart-v2 [contactType]="contactType"
                       [isVisible]="isVisible"
                       [displayFooter]="true"
                       [displayHeader]="false"
                       (pointHovered)="onPointHovered(chart3,$event)"
                       (pointOut)="onPointOut(chart3,$event)"
                       (setExtremes)="onSetExtremes($event)"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [viewMode]="gridContext?.viewMode"
                       [gridContext]="gridContext"
                       [isLoading]="isLoading"
                       (paramsListChanged)="onParamsListChanged($event,3)"
                       [sidebar]="sidebar[3]"
                       [chartId]=3
                       #chart3
                       (drillDown)="updateViewMode(false)"
                       (rollUp)="updateViewMode(true)"
                       (displayParams)="onDisplayParams(3)"
                       [locale]="locale"
    ></plan-detail-chart-v2>


  </div>

  <div class="overlay" *ngIf="isSidebarOpen" (click)="onCloseParams()">

  </div>
</div>

<div class="params-list-container col-params" *ngIf="isSidebarOpen" @paramsAnimation
     role="dialog" aria-modal="true" [attr.aria-label]="'chart.params.title' | translate">
  <div class="list-header">
    <button type="button" class="close-sidebar-btn" (click)="onCloseParams()" [attr.aria-label]="'chart.params.close.aria' | translate" [title]="'btn.close' | translate">
      <svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
        <title>{{'btn.close' | translate}}</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Close" fill="#777F8B" fill-rule="nonzero">
            <path d="M4.81454545,4 L7.54909091,1.26545455 C7.78181818,1.03272727 7.78181818,0.683636364 7.54909091,0.450909091 C7.31636364,0.218181818 6.96727273,0.218181818 6.73454545,0.450909091 L4,3.18545455 L1.26545455,0.392727273 C1.03272727,0.16 0.683636364,0.16 0.450909091,0.392727273 C0.218181818,0.625454545 0.218181818,0.974545455 0.450909091,1.20727273 L3.18545455,4 L0.450909091,6.73454545 C0.218181818,6.96727273 0.218181818,7.31636364 0.450909091,7.54909091 C0.683636364,7.78181818 1.03272727,7.78181818 1.26545455,7.54909091 L4,4.81454545 L6.73454545,7.54909091 C6.96727273,7.78181818 7.31636364,7.78181818 7.54909091,7.54909091 C7.78181818,7.31636364 7.78181818,6.96727273 7.54909091,6.73454545 L4.81454545,4 L4.81454545,4 Z" id="Path"></path>
          </g>
        </g>
      </svg>
    </button>
    <span class="params-title">{{'chart.params.title' | translate}}</span>
    <span *ngIf="contactType=='CT'" class="sub-title pull-right">{{'chart.yaxis.title' | translate}}</span>
  </div>


  <checkbox-list *ngIf="contactType=='CT'" [items]="paramsList[currentParamsList]" (itemChanged)="onParamSelectionChange($event)">

  </checkbox-list>

  <radiobutton-list *ngIf="contactType=='MU'" [items]="paramsList[currentParamsList]" (itemChanged)="onParamSelectionChange($event)">

  </radiobutton-list>

</div>


